import { render, staticRenderFns } from "./NoPresentations.vue?vue&type=template&id=3b871d93&scoped=true&"
import script from "./NoPresentations.vue?vue&type=script&lang=js&"
export * from "./NoPresentations.vue?vue&type=script&lang=js&"
import style0 from "./NoPresentations.vue?vue&type=style&index=0&id=3b871d93&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b871d93",
  null
  
)

export default component.exports